import { get } from '../../utils/objectHelpers';
import storeEvent from '../../utils/store-event';

export default class {
    onCreate(input) {
        let tabs = get(input, 'tabs', []);
        tabs = tabs.filter(tab => (
            get(tab, 'textSpans.0.text', null) &&
            get(tab, 'action.params.regionKey', null)
        ));
        tabs.forEach(tab => {
            this.constructor.addTabProperties(tab);
        });
        if (tabs.length) {
            this.state = {
                tabs,
                selectedIndex: 0,
                selectedPanelId: tabs[0].panelId,
                isSticky: false
            };
        }
    }
    onMount() {
        this.initElements();
        window.addEventListener('hashchange', this.handleHashChange.bind(this), false);
        this.handleHashChange.bind(this)(); // Change to correct tab when page loads.
        storeEvent.changeToTab.listen(data => {
            const tabIndex = get(data, 'tabIndex', null);
            const skipFocus = get(data, 'skipFocus', null);
            if (typeof tabIndex === 'number') {
                this.selectTab(tabIndex, skipFocus);
            }
        });
    }
    onDestroy() {
        window.removeEventListener('hashchange', this.handleHashChange.bind(this));
    }
    handleHashChange() {
        const hash = document.location.hash.replace('#', '').toLowerCase();
        let foundIndex = -1;

        if (hash) { // Homepage (tab0) may not have hash
            for (let i = 0, n = this.state.tabs.length; i < n; i++) {
                const tab = this.state.tabs[i];
                const name = get(tab, 'action.params.regionKey', '').toLowerCase();
                if (name === hash) {
                    foundIndex = i;
                    break;
                }
            }
        } else {
            foundIndex = 0;
        }

        if (foundIndex > -1) {
            this.selectTab(foundIndex);
        }
    }
    initElements() {
        this.root = this.getEl('str-tablist');
        this.tabEls = this.root.querySelectorAll('[role=tab]');
    }
    handleKeydown(evt) {
        const targetTab = evt.target;
        let index;
        if (evt.keyCode === 37) { // Left arrow
            index = this.findNextTabIndex(targetTab, 'left');
        } else if (evt.keyCode === 39) { // Right arrow
            index = this.findNextTabIndex(targetTab, 'right');
        } else {
            index = this.state.selectedIndex;
        }
        this.selectTab(index);
    }
    selectTab(selectedIndex, skipFocus) {
        if (typeof selectedIndex === 'number' && selectedIndex !== this.state.selectedIndex) {
            this.state.selectedIndex = selectedIndex;
            const selectedTab = this.tabEls[this.state.selectedIndex];
            if (!skipFocus) {
                selectedTab.focus();
            }
            this.state.selectedPanelId = selectedTab.getAttribute('aria-controls');

            // Change the hash last, after setting variables
            const regionKey = get(this, `state.tabs.${this.state.selectedIndex}.action.params.regionKey`, '');
            const newHash = this.state.selectedIndex !== 0
                ? `#${regionKey.toLowerCase()}`
                : window.location.pathname + window.location.search;
            window.history.pushState('', '', newHash);
            this.handleHashChange();
            this.emitTabHasChangedEvent(this.state.selectedIndex, this.state.selectedPanelId);
        }
    }
    findNextTabIndex(targetTab, direction) {
        for (let i = 0, n = this.tabEls.length; i < n; i++) {
            if (this.tabEls[i] === targetTab) {
                if (i === n - 1) {
                    return direction === 'right' ? 0 : i - 1;
                } else if (i === 0) {
                    return direction === 'right' ? i + 1 : n - 1;
                }
                return direction === 'right' ? i + 1 : i - 1;
            }
        }
    }
    emitTabHasChangedEvent(tabIndex, panelId) {
        const hash = document.location.hash.replace('#', '').toLowerCase();
        document.dispatchEvent(new CustomEvent('str-tab-change-event', {
            detail: {
                tabIndex: tabIndex,
                hash: hash,
                panelId: panelId
            }
        }));
    }
    static addTabProperties(tab) {
        tab.regionKey = get(tab, 'action.params.regionKey', '');
        tab.panelId = `str-tabpanel-${tab.regionKey.toLowerCase()}`;
        tab.tabId = `str-tab-${tab.regionKey.toLowerCase()}`;
    }
}

